import { BASE_URL } from '@helpers/constants'
import setAuthorization from '@helpers/setAuthorization'
import {
	ListCategoriesRequest,
	ListCategoriesResponse,
} from '@models/categories.model'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const categoriesApi = createApi({
	reducerPath: 'categoriesAPI',
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: (headers, { endpoint, getState }) =>
			setAuthorization(headers, { getState, endpoint }),
	}),
	endpoints: (builder) => ({
		getCategories: builder.query<ListCategoriesResponse, ListCategoriesRequest>(
			{
				query: ({ page = 1, search = '', limit = 10 }) => ({
					url: `/course-categories?page=${page}&search=${encodeURIComponent(
						search
					)}&limit=${limit}`,
					method: 'GET',
				}),
			}
		),
	}),
})
